import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { StringIntRequest } from "../../guardian-type-setup/shared/StringIntRequest";
import { DataService_Locker } from "../shared/data.service";

@Component({
	selector: "caass-locker-history-table",
	templateUrl: "./locker-history-table.component.html",
	styleUrls: ["./locker-history-table.component.css"],
})
export class LockerHistoryTableComponent implements OnInit {
	constructor(private LockerHistoryService: DataService_Locker, private confirmationService: ConfirmationService) {}

	//INSERT ON INIT HERE
	ngOnInit(): void {
		if (this.SelectedLocker == undefined) {
			this.LockerNum = "";
		} else {
			this.LockerNum = this.SelectedLocker.LockerNum;
		}

		this.loadLockerPerson();
	}

	ngOnChanges() {
		if (this.SelectedLocker == undefined) {
			this.LockerNum = "";
		} else {
			this.LockerNum = this.SelectedLocker.LockerNum;
		}

		this.loadLockerPerson();
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	@Input() SelectedLocker: any;
	@Output() UpdateParent: EventEmitter<any> = new EventEmitter();

	LockerNum: any = "";

	processing: any = false;

	///////////////
	// Built-In
	///////////////

	user: any;
	pagerows: any = 5;
	pagefirst: any = 0;
	loading: any = false;
	errorMessage: any = "";

	///////////////

	///////////////
	// Custom
	///////////////

	//Main
	SelectedLockerPerson: any;
	lstLockerPerson: any = [];

	//Filter lists
	lstActiveDesc: any = [];

	//Cols
	cols: any = [
		//INSERT CUSTOM COLUMNS HERE
		{ field: "StudentID", header: "Student ID" },
		{ field: "LastName", header: "Last Name" },
		{ field: "FirstName", header: "First Name" },
		{ field: "MoveInDateDesc", header: "Date In" },
		{ field: "MoveOutDateDesc", header: "Date Out" },
		// { field: 'Comments', header: 'Comments' },
		// { field: 'ActiveDesc', header: 'Active' },
	];

	///////////////

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////

	loadLockerPerson() {
		this.errorMessage = "";

		if (this.SelectedLocker == undefined) {
			this.lstLockerPerson = [];
			this.SelectedLockerPerson = null;
			return;
		}

		this.loading = true;

		var result = this.LockerHistoryService.LockerHistoryInfoSelectList(this.SelectedLocker.LockerID);
		result.subscribe(
			(response) => {
				this.lstLockerPerson = response;

				//Load Data Filter Lists
				this.lstActiveDesc = Array.from(new Set(this.lstLockerPerson.map((item: any) => item.ActiveDesc))).sort();

				this.loading = false;
			},
			(error) => {
				this.loading = false;
			}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////

	onRefresh() {
		this.loadLockerPerson();
	}

	//Custom Button Methods
	onSave(LockerPerson) {
		this.processing == true;

		//
		// Create Request
		//
		let parms: StringIntRequest = {
			num: LockerPerson.LockerPersonID,
			str: LockerPerson.Comments,
		};

		//
		// Call WS
		//
		var result = this.LockerHistoryService.LockerPersonUpdateComments(parms);
		result.subscribe(
			(response) => {
				this.processing = false;
				if (response) {
					var data: any = [];
					data = [...data, this.SelectedLocker];
					data = [...data, LockerPerson];

					this.UpdateParent.emit(data); //Update comments on parent
					this.loadLockerPerson();
				} else {
					//Error
					this.confirmationService.confirm({
						key: "history",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not update the locker history entry",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {
				this.processing = false;
			}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Events
	////////////////////////////////////////////
	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {
		this.SelectedLockerPerson = val.data;
	}
	onRowUnselect(val) {
		this.SelectedLockerPerson = null;
	}
	onRowDblClick(LockerPerson) {
		this.SelectedLockerPerson = LockerPerson;
	}
	////////////////////////////////////////////

	////////////////////////////////////////////
	// Helpers
	////////////////////////////////////////////

	LockerExists() {
		return this.SelectedLocker != undefined;
	}

	IsLoading() {
		return this.loading == true || this.processing == true;
	}

	////////////////////////////////////////////
}
